import React from 'react';

const Header = () => {
  return (
    <header className="app-header">
      <h1 className='header-logo'>FOLLOW-UP</h1>
    </header>
  );
};

export default Header;
